import React from 'react';
import { ShieldCheck, Edit3, Info, AlertTriangle } from 'lucide-react';

const BannerPermisoEdicion = ({ usuario }) => {
  // Verificamos el permiso
  const permisoActualizar = usuario?.actualizarTutor;

  if (!permisoActualizar) return null;

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-2xl p-6 mb-8 shadow-sm">
      {/* Decoración de fondo */}
      <div className="absolute top-0 right-0 -mt-4 -mr-4 opacity-10">
        <ShieldCheck size={120} className="text-emerald-500" />
      </div>

      <div className="flex flex-col md:flex-row items-start md:items-center gap-5 relative z-10">
        {/* Icono Principal */}
        <div className="bg-white p-3 rounded-xl shadow-md border border-emerald-100">
          <Edit3 className="text-emerald-600" size={28} />
        </div>

        <div className="flex-1">
          <h3 className="text-emerald-900 font-bold text-lg flex items-center gap-2">
            Tu perfil está habilitado para edición
            <span className="bg-emerald-200 text-emerald-800 text-[10px] uppercase px-2 py-0.5 rounded-full font-black tracking-widest">
            </span>
          </h3>
          
          <p className="text-emerald-800/80 text-sm mt-1 leading-relaxed">
            Tienes permisos para gestionar: 
            <span className="font-semibold text-emerald-900"> Materias</span>, 
            <span className="font-semibold text-emerald-900"> tipos de servicios</span>, 
            <span className="font-semibold text-emerald-900"> foto de perfil</span> y 
            <span className="font-semibold text-emerald-900"> cuentas bancarias</span>.
          </p>
          
          <div className="flex items-center gap-2 mt-3 text-emerald-700">
            <Info size={14} className="animate-pulse" />
            <span className="text-xs italic font-medium">
              Aprovecha y actualiza con responsabilidad.
            </span>
          </div>
        </div>

        
      </div>

      {/* Franja sutil de advertencia al final */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-emerald-500/20"></div>
    </div>
  );
};

export default BannerPermisoEdicion;